import {
    type CreateFormResponseType,
    type CreateFormRequestType
} from "./type";
import {
    request
} from "../request";

const CreateForm = async (params: CreateFormRequestType): Promise<CreateFormResponseType> => {
    return await request<CreateFormResponseType>("/events/createForm", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default CreateForm;
